import { render } from "./ResetChangePassword.vue?vue&type=template&id=df639492"
import script from "./ResetChangePassword.vue?vue&type=script&lang=js"
export * from "./ResetChangePassword.vue?vue&type=script&lang=js"

import "./ResetChangePassword.vue?vue&type=style&index=0&id=df639492&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__